import './App.css';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query'
import SignIn from './pages/users/signin';
import React from 'react';
import Users from './pages/users/users';
import ContextProvider from './contexts';
import Dashboard from './pages/dashboard';
import Registery from './pages/registery/registery';
import Inventory from './pages/inventory/inventory';
import Models from './pages/inventory/models';
import Insert from './pages/inventory/insert';
import PartDetails from './pages/inventory/part-datails';
import Sales from './pages/sales/sales';
import Firms from './pages/sales/firms';
import Invoices from './pages/sales/Invoices';
import Delivery from './pages/inventory/delivery';
import ProformaPrint from './pages/sales/proforma';

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false, refetchOnMount: false } } })

function App() {
  return (
    <QueryClientProvider client={queryClient}>

      <ContextProvider>
        <Router>
          <Switch>
            <Route path="/dashboard" exact>
              <Dashboard />
            </Route>
            <Route path="/registery" exact>
              <Registery />
            </Route>
            <Route path="/inventory/models" exact>
              <Models />
            </Route>
            <Route path="/signin" exact>
              <SignIn />
            </Route>
            <Route path="/users" exact>
              <Users />
            </Route>
            <Route path="/inventory" exact>
              <Inventory />
            </Route>
            <Route path="/inventory/delivery" exact>
              <Delivery />
            </Route>
            <Route path="/inventory/parts/:id">
              <PartDetails />
            </Route>
            <Route path="/inventory/insert" exact>
              <Insert />
            </Route>
            <Route path="/sales" exact>
              <Sales />
            </Route>
            <Route path="/sales/firms" exact>
              <Firms />
            </Route>
            <Route path="/sales/invoices" exact>
              <Invoices />
            </Route>
            <Route path="/sales/proforma/:id">
              <ProformaPrint />
            </Route>

            <Route path="/">
              <Redirect to="/dashboard" />
            </Route>
          </Switch>
        </Router>
      </ContextProvider>
    </QueryClientProvider>
  );
}

export default App;
